export const COLORS = {
  black: "#000000",
  white: "#ffffff",
  primary: "#DF3127",
  lightGrey: "#F1F1F1",
  darkGrey: "rgba(0,0,0,0.65)",
  lightRed: "#FFEFF0",
};
